<template>
  <section class="team-content">
    <div class="left">
      <div class="first">
        <div class="teamBig">
          <form id="logo_upload" action="/api/upload_logo" method="POST" enctype="multipart/form-data" ref="imgForm">
            <div class="logo_box">
              <img id="logo" :src="logoUrl" alt="" />
              <input v-if="permission_upload_logo" type="file" name="logo" @change="submit"/>
            </div>
          </form>
          <div v-if="permission_upload_logo" class="uploadtips">Upload Logo</div>
        </div>
        <div class="teamDetail">
          <div class="info">
            <div class="name"><span :title="teamName">{{teamName}}</span></div>
            <div class="status">Ranking: <span>{{rank}}/{{total_teams}}</span></div>
            <div class="status">{{score_}}: <span>{{score}}</span></div>
            <div class="status" v-if="profile.token">{{teamToken_}}: <span class="token">{{profile.token}}</span></div>
          </div>

        </div>
      </div>
      <!--first ends and second start-->
      <div class="second">
        <span>{{solvedChallenges_}}:<i class="number">{{solved}}</i><i>{{solved_}}</i><i class="sep">/</i><i class="number">{{total_problems}}</i><i>{{total_}}</i></span>
        <ul class="table">
          <li class="thead">
            <a>
              <span>{{name_}}</span>
              <span>{{score_}}</span>
              <span>{{solvedBy_}}</span>
              <span>{{time_}}</span>
            </a>
          </li>
          <li class="tr" v-for="r in result">
            <router-link :to="r.pid && '/challenge/'+r.pid || ''">
              <span>{{r.title}}</span>
              <span>{{r.score}}</span>
              <span>{{r.solver}}</span>
              <span>{{formatTime(r.timestamp)}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div v-if="ctfMode == 'teams'" class="third">
        <span>{{teamMembers_}}</span>
        <ul class="table">
          <li class="thead">
            <a>
              <span>{{hacker_}}</span>
              <span>{{score_}}</span>
              <span>{{solved_}}</span>
            </a>
          </li>
          <li class="tr" v-for="r in members" >
            <a>
              <span >{{r.uid}}</span>
              <span >{{r.rating}}</span>
              <span >{{r.solved}}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="right">
      <div class="first" v-if="true">
        <ul class="table rank">
          <li class="thead">
            <a>
              <span>Ranking</span>
              <span>Team</span>
            </a>
          </li>
          <li class="tr" v-for="(r, index) in rankInfo">
            <router-link :to="r.tid && '/team/'+r.tid || ''">
              <span>{{index + 1}}</span>
              <span>{{r.name}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  import { team, rank, top, uploadLogo } from '@/utils/api.js'
  import { getCountryName } from '@/utils/country.js'
  import { natural, formatTime } from '@/utils'
  import i18n from '@/i18n'
  import bus from '@/utils/event_bus.js'

  export default {
    data () {
      return {
        teamName: '',
        logoUrl: '/logo/_.png',
        flagTitle: '',
        flagURL: '',
        rank: 0,
        total_teams: 0,
        score: 0,
        size: 0,
        solved: 0,
        total_problems: 0,
        result: [],
        members: [],
        rankInfo: []
      }
    },
    computed: {
      ...mapState(['profile', 'v_locale', 'ctfMode']),
      ...mapGetters([]),
      ...i18n.map([
        'rank_', 'score_', 'teamMembers_', 'location_',
        'teamToken_', 'clickToUpload_', 'solvedChallenges_',
        'solved_', 'total_', 'name_', 'score_', 'solvedBy_',
        'time_', 'teamMembers_', 'hacker_', 'score_', 'solved_',
        'topTeams_', 'rank_', 'team_'
      ])
    },
    methods: {
      ...mapMutations([]),
      ...mapActions([]),
      formatTime,
      submit () {
        const fd = new FormData(this.$refs.imgForm)
        uploadLogo(fd)
          .then((data) => {
            this.logoUrl = data.logo
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      },
      init () {
        team(this.$route.params.tid)
          .then((data) => {
            if (data && data.country) {
              this.flagURL = `/flags/${data.country.toLowerCase()}.png`
              this.flagTitle = getCountryName(data.country)
            }
            this.teamName = data.name
            this.logoUrl = data.logo || '/logo/_.png'
            this.solved = data.solved.length
            this.score = data.rating
            this.size = data.size || 1
            this.rank = natural(data.rank)
            this.total_teams = natural(data.total_teams)
            this.total_problems = natural(data.total_problems)
            this.profile.token = data.token
            this.permission_upload_logo = data.permission_upload_logo

            this.result = data.solved || []
            this.members = data.members || []

            return data.tid
          })
          .then((tid) => {
            return rank()
              .then((data) => {
                for (let i in data.rank) {
                  if (data.rank[i].tid === tid) {
                    this.rank = natural(i + 1)
                    break
                  }
                }
              })
          })
          .catch((err) => {
            const [error] = err.message.split(': ')
            if (error === 'notfound' || error === 'noteam') return this.$router.push('/profile')

            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
        top().then((data) => {
          this.rankInfo = data.data
        })
      }
    },
    created () {
      this.init()
      bus.$on('UPDATE', this.init)
    },
    beforeDestroy () {
      bus.$off('UPDATE', this.init)
    }
  }
</script>

<style lang="less" scoped>
  .team-content {
    margin-top: 50px;
  }
  .team-content {
    font-family: "OCRAbyBT";
    .left {
      padding-right: 20px;
      border-right: 1px solid #e3e3e3;
      .first {
        font-size: 14px;
        display: flex;
        overflow: hidden;
        .teamBig {
          width: 150px;
          height: 150px;
          .logo_box>img{
            display:inline-block;
            width: 150px;
            height: 150px;
          }
          input[type="file"] {
            width: 150px;
            height: 150px;
          }
          img {
            cursor: pointer;
          }
          .uploadtips{
            position: absolute;
            left: 0;
            top: 160px;
            width: 150px;
            font-family: 'Courier';
            text-align: center;
          }
        }
        .teamDetail {
          .info {
            display: flex;
            flex-direction: column;
            height: 150px;
            border-bottom: none;
            .name {
              height: 25%;
              text-overflow: ellipsis;
              span {
                width: 450px;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
            .status {
              height: 25%;
              line-height: 58px;
              span {
                font-family: 'Courier';
              }
            }
          }
          .operation {
            .token {
              font-family: "normal";
            }
          }
        }
      }
      //first line ends and second start
      .second {
        &>span {
          color: #00cee3;
          font-size: 28px;
          i {
            font-family: 'OCRAbyBT';
            font-size: 28px;
          }
          i.number {
            font-size: 28px;
          }
          i.sep {
            font-size: 28px;
          }
        }
        ul.table {
          .tr{
            a > span{
              color:#fff;
            }
            a:hover > span {
              color: #00cee3;
            }
            a > span:not(:last-child) {
              border-right: 1px solid #e3e3e3;
            }
          }
          span{
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          a > span:nth-child(2) {
            width: 15%;
          }
          a > span:nth-child(3) {
            width: 24%;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            vertical-align: top;
          }
          a > span:nth-child(4) {
            width: 33%;
          }
        }
      }
      .third {
        &>span {
          font-family: "OCRAbyBT";
          color: #00c8e3;
          i {
          }

        }
        ul.table {
          .tr{
            a > span:not(:last-child) {
              border-right: 1px solid #e3e3e3;
            }
            span{
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
          }
        }
      }
    }
    // left ends and right begin
    .right {

      .first {
        ul.table {
          .thead{
            border-top: none;
            a>span{
              text-align: left;
            }
          }
          .tr>a>span{
            color: #fff;
            text-align: left;
          }
          .tr>a:hover>span{
            color: #00cee3;
          }
          a > span:nth-child(1) {
            width: 40%;
          }
          a > span:nth-child(2) {
            width: 60%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/themes/dragon/components/team.vue